import {
  AllBotsCategoryType,
  AllBotsCreatorType,
  BotsResponseType,
  SortBotsType,
  SortBotsValueType,
} from '@webclient/shared-types/bots';

import AwardRoundedIcon from '~icons/knowz-iconify/award';
import BuildingRoundedIcon from '~icons/knowz-iconify/building-rounded';
import FeatherRoundedIcon from '~icons/knowz-iconify/feather-rounded';
import FlexAlignBottomRoundedIcon from '~icons/knowz-iconify/flex-align-bottom-rounded';
import GlobaIcon from '~icons/knowz-iconify/glob';
import KnowzZRoundedIcon from '~icons/knowz-iconify/knowz-z-rounded';
import LaughterRoundedIcon from '~icons/knowz-iconify/laughter-rounded';
import ToolRoundedIcon from '~icons/knowz-iconify/tool-rounded';
import TridentRoundedIcon from '~icons/knowz-iconify/trident-rounded';
import UserRoundedIcon from '~icons/knowz-iconify/user';

const ALL_CATEGORIES: {
  name: AllBotsCategoryType;
  value: AllBotsCategoryType;
  icon: React.ReactNode;
}[] = [
  {
    name: 'All',
    value: 'All',
    icon: <FlexAlignBottomRoundedIcon />,
  },
  {
    name: 'Productivity',
    value: 'Productivity',
    icon: <ToolRoundedIcon />,
  },
  {
    name: 'Historical',
    value: 'Historical',
    icon: <BuildingRoundedIcon />,
  },
  {
    name: 'Fictional',
    value: 'Fictional',
    icon: <FeatherRoundedIcon />,
  },
  {
    name: 'Fun',
    value: 'Fun',
    icon: <LaughterRoundedIcon />,
  },
  {
    name: 'Mythical',
    value: 'Mythical',
    icon: <TridentRoundedIcon />,
  },
];

const ALL_CREATORS: {
  name: AllBotsCreatorType;
  value: AllBotsCreatorType;
  icon: React.ReactNode;
}[] = [
  {
    name: 'Everyone',
    value: 'Everyone',
    icon: <GlobaIcon />,
  },
  {
    name: 'Knowz',
    value: 'Knowz',
    icon: <KnowzZRoundedIcon />,
  },
  {
    name: 'You',
    value: 'You',
    icon: <UserRoundedIcon />,
  },
];

const ALL_SORTS: {
  name: SortBotsType;
  value: SortBotsValueType;
  icon: React.ReactNode;
}[] = [
  {
    name: 'Popularity',
    value: 'ASC',
    icon: <AwardRoundedIcon />,
  },
];

const CATEGORY_BY_ICONS: Record<
  Exclude<AllBotsCategoryType, 'All'>,
  React.ReactNode
> = {
  Fictional: <FeatherRoundedIcon />,
  Fun: <LaughterRoundedIcon />,
  Historical: <BuildingRoundedIcon />,
  Productivity: <ToolRoundedIcon />,
  Mythical: <TridentRoundedIcon />,
  'Knowz AI': <KnowzZRoundedIcon />,
};

const DEFAULT_KNOWZ_AI_BOT: BotsResponseType[number] & {
  avatar: string;
  descriptionTranslationKey: string;
} = {
  image: 'public/bots/knowz/portrait/knowz-ai.webp',
  id: 0,
  name: 'Knowz AI',
  description: 'The default Knowz AI - a useful, friendly guide',
  descriptionTranslationKey: 'page.home.gamification.knowzBot.description',
  styleId: null!,
  createdAt: Date.now().toString(),
  updatedAt: Date.now().toString(),
  category: 'Knowz AI',
  owner: null,
  animationVideo: 'https://asset.knowz.com/assets/medias/videos/knowz-ai.mp4',
  introAudio: null,
  isDefaultOwner: true,
  avatar: 'https://asset.knowz.com/assets/images/knowz-bot-orb.png',
  communityBots: true,
  threadCount: 0,
};

const CONFIG = {
  ALL_CATEGORIES,
  ALL_CREATORS,
  ALL_SORTS,
  CATEGORY_BY_ICONS,
  DEFAULT_KNOWZ_AI_BOT,
} as const;

export default CONFIG;
